import React from 'react';
import { Row } from 'antd';
import { Image, MenuContainer, MenuItem, MenuText } from '../../../../shared.style';
import FolderIcon from '../../../../assets/icons/folder.png';

const MenuAccountDocument = ({ history }) => {
  return (
    <MenuContainer>
      <Row justify="center">
        <MenuItem
          onClick={() => history.push(`/account/documents`)}>
          <Image src={FolderIcon} alt="documents" />
        </MenuItem>
      </Row>
      <Row justify="center">
        <MenuText>รูปภาพและเอกสาร</MenuText>
      </Row>
    </MenuContainer>
  );
};

export default MenuAccountDocument;



// WEBPACK FOOTER //
// ./src/pages/Account/components/MenuAccountDocument/index.js